import { genericGet, genericPost } from './apiService';
import { fetchFilteredBlogs, setLoading, setError } from '../redux/slices/blogSlice';
import { API_URL } from '../config/env';

export const getFilteredBlogs = async (dispatch, params) => {
  try {
    dispatch(setLoading(true));
    dispatch(setError(null));

    const request = {
      filters: params.filters || [],
      pageIndex: params.pageIndex || 1,
      pageSize: params.pageSize || 10,
      sortBy: params.sortBy || 'CreatedDate',
      sortOrder: params.sortOrder || 'desc'
    };

    const response = await genericPost(`${API_URL}Blog/GetFilter`, request);
    
    if (response?.statusCode === 200) {
      dispatch(fetchFilteredBlogs(response));
      dispatch(setLoading(false));
      return response;
    }
    
    dispatch(setError(response?.message || 'An error occurred'));
    dispatch(setLoading(false));
    return response;
  } catch (error) {
    console.error('Error fetching blogs:', error);
    dispatch(setError(error.message));
    dispatch(setLoading(false));
    return { succeeded: false, error: error.message };
  }
};

// FilterCriteria oluşturmak için yardımcı fonksiyon
export const createFilterCriteria = (propertyName, operation, value) => {
  return {
    propertyName,
    operation,
    value: value.toString()
  };
};

// Blog servisi için filtre operatörleri - case-sensitive olarak güncellendi
export const FilterOperators = {
  EQUALS: '==',
  CONTAINS: 'Contains',
  GREATER_THAN: '>=',
  LESS_THAN: '<=',
  NOT_EQUALS: '!=',
  IN: 'In',
  STARTS_WITH: 'StartsWith',
  ENDS_WITH: 'EndsWith',
  DOES_NOT_CONTAIN: 'DoesNotContain',
  IS_NULL: 'IsNull',
  IS_NOT_NULL: 'IsNotNull'
};

export const getBlogBySlug = async (slug) => {
  try {
    const response = await genericGet(`${API_URL}Blog/GetSlug?slug=${slug }`, null);
    return response;
  } catch (error) {
    console.error('Error fetching blog detail:', error);
    return { succeeded: false, error: error.message };
  }
};

export const blogService = {
  getFilteredBlogs,
  createFilterCriteria,
  FilterOperators,
  getBlogBySlug
};

export default blogService; 